export default {
    da: {
        pageHeader: 'Nyhedsbrev',
        info: 'Indtast din email-adresse for at til- og afmelde biografens nyhedsbreve ',
        email: 'Email',
        find: 'Videre',
        invalidInput: 'Ugyldig email',
        subscribed: 'Tilmeldt',
        unsubscribed: 'Frameldt',
    },

    en: {
        pageHeader: ' Newsletters',
        info: 'Subscribe or unsubscribe ',
        email: 'Email',
        find: 'Search',
        invalidInput: 'Invalid email'
    },

    fo: {
        pageHeader: 'Tíni tíðindabrøv',
        info: ' Tilmelda ella avmelda',
        email: 'teldupostur',
        find: 'leita',
        invalidInput: 'Skeivur teldupostur'
    }

    //new: {
    //  pageHeader: '',
    //  info: ' ',
    //  email: '',
    //  find: '',
    //  invalidInput: ''
    //}
}